import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '../tooltip';

const Comment = ({ id, comment }) => {
  if (!comment) return null;

  // Raw comments sometimes embed literal newlines/runs of whitespace (e.g. "BAN: X\nKANA...")
  // which caused odd mid-word wrapping - normalize before measuring/truncating. Character-based
  // (not word-count) truncation so near-identical comments ("Auto-approved" vs "Auto Approved")
  // don't cut off at different points purely due to hyphenation/spacing differences upstream.
  const normalizedComment = comment.replace(/\s+/g, ' ').trim();
  const maxChars = 35;
  const shortComment = `${normalizedComment.substring(0, maxChars)}...`;

  return normalizedComment.length > maxChars ? (
    <Tooltip id={id} message={normalizedComment} icon="fa-info-circle">
      {shortComment}
    </Tooltip>
  ) : (
    normalizedComment
  );
};

Comment.propTypes = {
  id: PropTypes.string.isRequired,
  comment: PropTypes.string.isRequired
};

export default Comment;
